import { ListCustomizer } from '@kinet-open-network/client/core/forms/ui';
import { ProductPrice } from '@kinet-open-network/client/product-prices/data-access';
import { ProductPricesListComponent } from '@kinet-open-network/client/product-prices/feature/list';
import {
  TableConfig,
  confirmDialog,
  toast,
} from '@kinet-open-network/client/shared/ui';
import { AppProductPricesStore } from '../+state/app-product-prices.store';

type ProductPricesStoreInstance = InstanceType<typeof AppProductPricesStore>;

export const productPricesListCustomization: ListCustomizer<
  ProductPrice,
  ProductPricesListComponent
> = (context) => {
  const ability = context.abilityService.ability();
  const store = context.store as unknown as ProductPricesStoreInstance;

  const config: TableConfig<ProductPrice> = {
    header: {
      actions: [
        {
          label: 'Importovať',
          icon: 'pi pi-upload',
          routerLink: () => ['imports'],
          disabled: ability?.cannot('import', 'ProductPrice'),
        },
        {
          label: 'Exportovať',
          icon: 'pi pi-download',
          command: () => store.export(),
          disabled: ability?.cannot('export', 'ProductPrice'),
        },
        {
          label: 'Exportovať pre ONIX',
          icon: 'pi pi-download',
          command: () => store.exportForOnix(),
          disabled: ability?.cannot('export', 'ProductPrice'),
        },
      ],
    },
    stateKey: 'product-prices',
    actions: [
      {
        label: 'Detail',
        icon: 'pi pi-eye',
        routerLink: (productPrice) => [productPrice.id],
        context: ['row', 'menu', 'contextMenu'],
        visible: (productPrice) =>
          ability?.can('read', productPrice) &&
          ability?.cannot('update', productPrice),
      },
      {
        label: 'Upraviť',
        icon: 'pi pi-pencil',
        routerLink: (productPrice) => [productPrice.id, 'edit'],
        context: 'all',
        visible: (productPrice) => ability?.can('update', productPrice),
      },
      {
        label: 'Vymazať',
        icon: 'pi pi-trash',
        context: ['menu', 'contextMenu'],
        visible: (productPrice) => ability?.can('delete', productPrice),
        command: (productPrice) =>
          confirmDialog({
            header: 'Potvrdenie vymazania',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Vymazať',
            rejectLabel: 'Zrušiť',
            acceptIcon: 'pi pi-trash mr-2',
            acceptButtonStyleClass: 'p-button-danger',
            rejectButtonStyleClass: 'p-button-secondary p-button-text',
            message: `Naozaj chcete vymazať ProductPrice?`,
            accept: () =>
              store
                .delete(productPrice.id)
                .then(() =>
                  toast({
                    severity: 'success',
                    summary: 'Product Price bolo úspešne vymazané',
                  }),
                )
                .finally(() => store.refreshPaginated()),
          }),
      },
      {
        label: 'Audit',
        icon: 'pi pi-history',
        routerLink: (productPrice) => [productPrice.id, 'audits'],
        context: ['menu', 'contextMenu'],
        visible: (productPrice) => ability?.can('read', productPrice),
      },
    ],
  };

  return { config };
};
